export type DashboardThemePreference = "dark" | "light" | "system";

const THEME_PREFERENCE_KEY = "refinement-canvas.dashboard.theme-preference";

export function loadDashboardThemePreference(): DashboardThemePreference {
  if (typeof window === "undefined") {
    return "system";
  }

  try {
    return normalizeThemePreference(localStorage.getItem(THEME_PREFERENCE_KEY));
  } catch {
    // ストレージを禁止したブラウザ設定では localStorage の参照・getItem 自体が例外を送出する。
    // main.tsx の起動処理（root.render の前）から呼ばれるため、ここで throw すると画面が真っ白になる。
    // 保存側と同様に既定値へフォールバックし、テーマ選好の復元だけを諦める。
    return "system";
  }
}

export function saveDashboardThemePreference(preference: DashboardThemePreference): void {
  try {
    localStorage.setItem(THEME_PREFERENCE_KEY, preference);
  } catch {
    // localStorage が使えない環境では、テーマ保存だけを諦める。
  }
}

function normalizeThemePreference(value: unknown): DashboardThemePreference {
  return value === "dark" || value === "light" || value === "system" ? value : "system";
}
